<template>
  <div class="category">
    <Skeleton v-if="!category" />
    <div class="category" v-else>
      <div class="category__header">
        <div class="container">
          <Title markup="h2" class="category__title">
            {{ category.title }}
          </Title>
          <SubCats :category="category" />
        </div>
      </div>
      <div class="category__recipes">
        <RecipeGrid v-if="recipes" :recipes="recipes" />
      </div>
    </div>
  </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import SubCats from "@/components/listing/SubCats.vue";
import RecipeGrid from "@/components/listing/RecipeGrid.vue";
import Skeleton from "@/components/skeleton/Skeleton.vue";
export default {
  name: "Category",
  components: {
    Skeleton,
    RecipeGrid,
    SubCats,
    Title
  },
  data() {
    return {
      currentPage: 1,
      perPage: -1,
      category: false,
      recipes: false,
      subcat: false,
      pageTitle: ""
    };
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  watch: {
    $route() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      if (this.$route.params.subcat) {
        this.fetchSubcat();
      }
      this.fetchCategory();
    },
    setPageTitle() {
      this.pageTitle = this.$route.params.subcat
        ? this.subcat.title
        : this.category.title;
    },
    async fetchSubcat() {
      const { subcat } = this.$route.params;
      const response = await this.getApi(
        "category/" + subcat + "?page=" + this.currentPage + "&per_page=-1"
      );
      this.subcat = response.category;
      this.recipes = response.recipes;
      this.setPageTitle();
    },
    async fetchCategory() {
      const response = await this.getApi(
        "category/" +
          this.$route.params.slug +
          "?page=" +
          this.currentPage +
          "&per_page=" +
          this.perPage
      );
      this.category = response.category;
      if (!this.$route.params.subcat) {
        this.recipes = response.recipes;
        this.setPageTitle();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.category {
  &__header {
    background: rgba($secondary, 0.15);
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    padding: 25px 0;
  }
  &__title {
    @include font-bigtitle();
    text-align: center;
    margin-top: 0;
    margin-bottom: 15px;
    line-height: 1;
    line-height: 25px;
    font-size: 34px;
  }
  &__recipes {
    margin-bottom: 40px;
  }
}
</style>
